var map = {
	"./AI搜索.svg": 20953,
	"./AI搜索123.svg": 32630,
	"./AI洞察.svg": 85188,
	"./AI洞察123.svg": 12896,
	"./AI知识库.svg": 89743,
	"./excel.svg": 25130,
	"./left-retract.svg": 45591,
	"./pdf.svg": 10082,
	"./ppt.svg": 16325,
	"./time.svg": 54570,
	"./txt.svg": 63483,
	"./word.svg": 47399,
	"./人员管理.svg": 43013,
	"./全部.svg": 5193,
	"./关键词设置.svg": 7528,
	"./历史记录.svg": 42198,
	"./垃圾.svg": 55613,
	"./导出情报.svg": 19305,
	"./情报中心.svg": 72946,
	"./我的收藏.svg": 68182,
	"./我的订阅.svg": 95807,
	"./报告库.svg": 73861,
	"./撤销.svg": 21441,
	"./播放.svg": 62487,
	"./收起.svg": 90380,
	"./星.svg": 97878,
	"./未知.svg": 69055,
	"./申请开票.svg": 55290,
	"./知识库.svg": 70449,
	"./知识库管理.svg": 49865,
	"./管理用户.svg": 41614,
	"./联系客户经理.svg": 16742,
	"./评论中心 - 副本.svg": 89663,
	"./评论中心.svg": 53053,
	"./阅读统计.svg": 63020
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42007;